import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApplicationPackage} from 'src/app/enums/application-package.enum';
import {Service} from 'src/app/enums/service.enum';
import {CustomHttpUrlEncodingCodec} from 'src/app/main/encoder';
import {Genre} from 'src/app/model/cms-vod-core/content-controller/genre-model';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GenreService {
  readonly genreApiUrl = environment.endPoint + ApplicationPackage.CMS_VOD + Service.GENRE;
  readonly channelGenreApiUrl = environment.endPoint + ApplicationPackage.CMS_BTV + Service.GENRE;
  constructor(private http: HttpClient) {}

  //Get All Genre
  getAllGenre(languageId?: number, genreName?: string, genreLangName?: string, sortParams?: string[]): Observable<Genre[]> {
    let queryParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});

    if (languageId) {
      queryParams = queryParams.set('languageId', <any>languageId);
    }
    if (genreName) {
      queryParams = queryParams.set('name', <any>genreName);
    }
    if (genreLangName && genreLangName.trim() != '') {
      queryParams = queryParams.set('langName', <any>genreLangName);
    }
    if (sortParams && sortParams.length > 0) {
      queryParams = queryParams.set('sortParam', <any>sortParams);
    }

    return this.http.get<Genre[]>(this.genreApiUrl, {params: queryParams});
  }

  //Ge Genre by id
  getGenreById(id: number): Observable<Genre> {
    return this.http.get<Genre>(this.genreApiUrl + `/${id}`);
  }

  //Edit Genre
  editGenre(genre: Genre): Observable<Genre> {
    return this.http.put<Genre>(this.genreApiUrl, genre);
  }

  //Add Genre
  addGenre(genre: Genre): Observable<Genre> {
    return this.http.post<Genre>(this.genreApiUrl, genre);
  }

  //Delete Genre
  deleteGenre(id: number): Observable<any> {
    return this.http.delete<any>(this.genreApiUrl + `/${id}`);
  }

  getAllChannelGenre(): Observable<Genre[]> {
    return this.http.get<Genre[]>(this.channelGenreApiUrl);
  }
}
